
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#3486ac"}},[_c('path',{attrs:{"d":"M12.46 0a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"}}),_c('path',{attrs:{"d":"M12.46 0a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"}})]),_c('path',{attrs:{"fill":"#3486ac","d":"M15.96 9.333h-7V28h2.333v-3.5h2.333V28h2.333v-3.5h2.334l-2.334-9.334zM3.5 0a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM7 9.333H0V28h2.334v-7h2.333v7H7z"}}),_c('path',{attrs:{"fill":"#83ca54","d":"M25.942 4.667a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM22.442 14v14h2.333v-4.667h2.334V28h2.333V14zM35.17 4.667a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM31.67 14v14h2.334v-4.667h2.333V28h2.334V14zM45.17 4.667a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM41.67 14v14h2.334v-4.667h2.333V28h2.334V14z"}})])
          )
        }
      }
    